import { Badge, type BadgeVariant } from '@cloudflare/kumo'
import {
  QUOTE_PAYMENT_SOURCES,
  type AdminQuoteView,
  type QuoteCloseReason,
  type QuotePaymentSource,
} from '@repo/shared'

/** 견적 결제 출처 (C32). 샌드박스는 TestFlight·심사·테스터 결제라 실결제와 갈라 본다 */
const PAYMENT_SOURCE_LABEL: Record<QuotePaymentSource, string> = {
  purchase: '실결제',
  included: '구독 포함',
  admin: '관리자 지급',
  sandbox: '샌드박스',
}
const PAYMENT_SOURCE_BADGE: Record<QuotePaymentSource, BadgeVariant> = {
  purchase: 'success',
  included: 'info',
  admin: 'outline',
  sandbox: 'warning',
}

/** 견적 목록의 결제 출처 거르기 선택지 */
export const PAYMENT_SOURCE_ITEMS = [
  { label: '결제: 전체', value: 'all' },
  ...QUOTE_PAYMENT_SOURCES.map((s) => ({ label: `결제: ${PAYMENT_SOURCE_LABEL[s]}`, value: s })),
]

/** 견적 목록·상세의 결제 출처 배지. 견적권 기록이 없으면(결제 끈 로컬·옛 요청) '—' */
export function PaymentSourceBadge({ source }: { source: AdminQuoteView['paymentSource'] }) {
  if (!source) return <span className="text-kumo-subtle text-xs">—</span>
  return <Badge variant={PAYMENT_SOURCE_BADGE[source]}>{PAYMENT_SOURCE_LABEL[source]}</Badge>
}

const CLOSE_REASON_LABEL: Record<QuoteCloseReason, string> = {
  user_cancelled: '고객 취소',
  no_offers: '제안 0건 마감',
}

/**
 * 마감 사유와 견적권 반환 (C48). 반환하면 견적권이 견적에서 풀려 결제 출처 배지가 '—' 가 되므로 반환 사실을 여기서 보인다.
 * 사유 없는 마감·옛 서버면 아무것도 그리지 않는다
 */
export function QuoteCloseBadge({
  quote,
}: {
  quote: Pick<AdminQuoteView, 'closeReason' | 'creditReturned'>
}) {
  if (!quote.closeReason && !quote.creditReturned) return null
  return (
    <>
      {quote.closeReason && (
        <Badge variant="outline">{CLOSE_REASON_LABEL[quote.closeReason]}</Badge>
      )}
      {quote.creditReturned && <Badge variant="info">견적권 반환</Badge>}
    </>
  )
}
